// extracted by mini-css-extract-plugin
module.exports = {"tertiary-icon":"tertiary-icon__YTAk-","icon":"icon__a6sIx"};